import { extractQueryState } from "@shared/utils/extractQueryState";
import { useQuery } from "@tanstack/react-query";
import { getSubscriptionFlowApiClient } from "@shared/apis/sidekick/api-factories";
import { MembershipAffiliationPriceDto } from "@shared/apis/sidekick/generated";
import {
  ApiError,
  apiResponseErrorHandler,
} from "@shared/apis/sidekick/api-error-handler";

const GET_MEMBERSHIP_AFFILIATION_PRICE_QUERY_KEY =
  "membership-affiliation-price";

type Props = {
  planId: string;
  enabled?: boolean;
  onError?: (error: ApiError) => void;
};

export const useGetMembershipAffiliationPrice = (props: Props) => {
  const { planId, enabled = true, onError } = props;
  const api = getSubscriptionFlowApiClient();
  const query = useQuery({
    queryKey: [GET_MEMBERSHIP_AFFILIATION_PRICE_QUERY_KEY, planId],
    queryFn: async (): Promise<MembershipAffiliationPriceDto> => {
      try {
        return await api.subscriptionFlowControllerGetMembershipAffiliationPrice(
          { planId },
        );
      } catch (e) {
        console.error("Error trying to fetch membership affiliation price", e);
        const error = await apiResponseErrorHandler(e);
        onError?.(error);
        throw error;
      }
    },
    enabled,
    refetchOnWindowFocus: false,
    retry: 3,
  });

  return extractQueryState(query);
};
